<dsw-footer-element [attr.locale]="locale"></dsw-footer-element>
